import React from "react";
import { Card } from "antd-mobile";

import "./style.scss";

function CustomCard(props) {
  return (
    <Card {...props} className="agent-mobile-custom-card">
      {props.children}
    </Card>
  );
}

export default CustomCard;
